import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { capitalizeWords } from "../../../utils/helpers";
import { DevDashboard } from "../protectedRoutes/Dashboards/developerDashboard";
import { TesterDashboard } from "../protectedRoutes/Dashboards/testerDashboard";
import { OwnerDashboard } from "../protectedRoutes/Dashboards/ownerDashboard";
import { AdminDashboard } from "../protectedRoutes/Dashboards/adminDashboard";
import { AssistantAdminDashboard } from "../protectedRoutes/Dashboards/assistantAdmin";
import { EmployeeDashboard } from "../protectedRoutes/Dashboards/employeeDashboard";
import { UserDashboard } from "../protectedRoutes/Dashboards/userDashboard";
import { updateUserRole } from "../../../redux/authSlice";

export function DashboardComponent(props) {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.auth.user);
  // console.log("Current User: ", currentUser);
  const [updatedRole, setUpdatedRole] = useState("");
  // console.log(updatedRole);
  const [userFeedback, setUserFeedback] = useState({
    message: "",
    type: "info",
  });

  const getUserDashboard = (key) => {
    switch (key) {
      case "DEVELOPER":
        return <DevDashboard />;
      case "TESTER":
        return <TesterDashboard />;
      case "OWNER":
        return <OwnerDashboard />;
      case "ADMIN":
        return <AdminDashboard />;
      case "ASSISTANT_ADMIN":
        return <AssistantAdminDashboard />;
      case "EMPLOYEE":
        return <EmployeeDashboard />;

      default:
        return <UserDashboard />;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (updatedRole === currentUser.role) {
      console.error("Nope");
      setUserFeedback({
        message: "New role cannot be the same as current role",
        type: "warning",
      });
    } else {
      // Submit updated role
      dispatch(
        updateUserRole({ userId: currentUser.userId, role: updatedRole })
      )
        .unwrap()
        .then((data) => {
          setUserFeedback(data);
        })
        .catch((error) => {
          console.log(error);
          setUserFeedback(error);
        });
    }
  };

  return (
    <section className="user-dashboard">
      <h1>
        Hello, {capitalizeWords(currentUser.username)} ({currentUser.role})
      </h1>
      {getUserDashboard(currentUser.role)}
      {/* <Counter /> */}
      <Link to="/test">Test Link</Link>
      <br />
      <label htmlFor="role-select">Choose a role:</label>
      <br />
      <form type="submit" onSubmit={(e) => handleSubmit(e)}>
        <select
          name="roles"
          id="role-select"
          onChange={(e) => setUpdatedRole(e.target.value.toUpperCase())}
        >
          <option value="">--Please choose an option--</option>
          <option value="Owner">Owner</option>
          <option value="Developer">Developer</option>
          <option value="tester">Tester</option>
          <option value="admin">Admin</option>
          <option value="assistant_admin">Assistant Admin</option>
          <option value="employee">Employee</option>
          <option value="user">User</option>
        </select>
        <br />
        <button>Submit</button>
        <div>
          <p>{userFeedback.message || null}</p>
        </div>
      </form>
    </section>
  );
}
